import { useInfiniteQuery, QueryKey, InfiniteData } from "@tanstack/react-query";

import { FEED_QUERY_KEYS } from "../queryKeys";
import { FeedResponse } from "../types/feed.types";
import { getFeedPosts } from "../services/feedServices";

import { PostTypeEnum } from "../../enums/post.enum";
import { FeedItem } from "../types/feed.types";

const FEED_PAGE_LIMIT = 20;

type QueryFnData = FeedResponse;
type PageParam = number;

interface TransformedData extends InfiniteData<QueryFnData, PageParam> {
  posts: FeedItem[];
}

export const useFeedListQuery = (postType?: PostTypeEnum) => {
  return useInfiniteQuery<QueryFnData, Error, TransformedData, QueryKey, PageParam>({
    queryKey: FEED_QUERY_KEYS.postsList(postType),
    queryFn: async ({ pageParam }: { pageParam: PageParam }) => {
      const response = await getFeedPosts(FEED_PAGE_LIMIT, pageParam, postType);
      return response as QueryFnData;
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage: QueryFnData, allPages: QueryFnData[]) => {
      if (lastPage.items.length === 0) {
        return undefined;
      }

      // Stop if we got fewer items than requested (indicates no more data)
      if (lastPage.items.length < FEED_PAGE_LIMIT) {
        return undefined;
      }

      // Calculate next offset and continue
      const currentOffset = allPages.reduce((acc: number, page: QueryFnData) => acc + page.items.length, 0);
      return currentOffset;
    },
    staleTime: 1000 * 60 * 5,
    select: (data) => ({
      ...data,
      posts:
        // data.pages.flatMap((page) => page.items.filter((item) => item.post.postType !== PostTypeEnum.CHALLENGE)) || [],
        data.pages.flatMap((page) => page.items) || [],
    }),
  });
};
